<div
  class="circle h-10 w-10 rounded-full flex justify-center items-center border-1 border-[#2E2E38 ] bg-[#F6F6F6] cursor-pointer"
  (click)="toggleNavbar()"
  [title]="isNavbarVisible ? 'Hide Navbar' : 'Show Navbar'"
>
  <i
    class="pi text-mdlz-primary"
    [ngClass]="{
      'pi-angle-up': isNavbarVisible,
      'pi-angle-down': !isNavbarVisible,
    }"
    aria-hidden="true"
  ></i>
</div>
